module.exports = __webpack_public_path__ + "media/placeholder-video.e9e2536c.mp4";